<template>
    <div
        class="d-flex flex-row flex-nowrap gap-4"
        v-if="detailtext != ''"
    >
        <ButtonComp
            @click="btnClick"
            :class="[props.buttonType != 'Custom' ? 'btn-xxs' : 'btn-sm']"
            :icon="props.icon"
            :buttonType="props.buttonType ?? 'Secondary'"
        >
            {{ $tm(text) }}
        </ButtonComp>
        <span>{{ detailtext }}</span>
    </div>

    <ButtonComp
        v-else
        @click="btnClick"
        :class="[props.buttonType != 'Custom' ? 'btn-xxs' : 'btn-sm']"
        :icon="props.icon"
        :buttonType="props.buttonType ?? 'Secondary'"
    >
        {{ $tm(text) }}
    </ButtonComp>
</template>
<script lang="ts" setup generic="TRow">
import { $tm } from '@/locize';
import { ButtonComp, type ButtonTypes } from '..';
import type { IIcon, IIconPosition } from '../Interfaces';
import { computed } from 'vue';

const props = defineProps<
    {
        row: TRow;
        text: string;
        buttonType?: ButtonTypes;
        onClick: (row: TRow) => void;

        /**
         * The rest of the text we want to show next to the icon
         */
        moretext?: (row: TRow) => string;
    } & IIcon &
        IIconPosition
>();

const btnClick = () => {
    props.onClick(props.row);
};

const detailtext = computed(() => {
    if (props.moretext) {
        return props.moretext(props.row);
    }

    return '';
});
</script>
